import { render, staticRenderFns } from "./VisitaGastroenterologicaEdit.vue?vue&type=template&id=73d41c20"
import script from "./VisitaGastroenterologicaEdit.vue?vue&type=script&lang=js"
export * from "./VisitaGastroenterologicaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports